/* eslint-disable */
/**
 * DO NOT EDIT THIS FILE
 */
import { KinesisTracker } from '@weberus/client-tracker';
import type { RoomPeople } from '../module/yanolja_standardcode/room-people';

/**
 * PageName: PRODUCT_LIST
 */
export const ProductListPageLog = {
  Search: {
    /**
     * SearchResult 진입
     * # Header
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L5}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    view({ logMeta }: ProductListPageLog.Search.View) {
      return KinesisTracker.view('PRODUCT_LIST', {
        clientEventId: 598,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        objectContainer: 'search',
        eventType: 'EVENT_TYPE_VIEW',
        ...logMeta,
      });
    },
  },

  SearchButtonBackward: {
    /**
     * 뒤로가기 버튼 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L16}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchButtonBackward.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 600,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'backward',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  SearchButtonHome: {
    /**
     * 홈 버튼 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L29}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchButtonHome.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 601,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'home',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  SearchButtonCart: {
    /**
     * 장바구니 버튼 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L42}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchButtonCart.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 602,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'cart',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  ButtonSearch: {
    /**
     * 검색창 버튼 클릭
     * # 카테고리 탭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L55}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.ButtonSearch.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 603,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'search',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  SearchTabBtnDisplayName: {
    /**
     * 탭 버튼 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L70}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/tab_item.proto#L0}
     */
    impression({ logMeta }: ProductListPageLog.SearchTabBtnDisplayName.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 604,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'displayTabName',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },

    /**
     * 탭 버튼 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L83}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/tab_item.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchTabBtnDisplayName.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 605,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'displayTabName',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  SearchTabBtnName: {
    /**
     * 탭 버튼 클릭 후 변경된 탭 로깅
     * 사용자가 ProductList 페이지에 진입한 초기 카테고리와 다른 카테고리를 처음 클릭한 경우 로깅
     *(예: '국내숙소' 카테고리에서 진입 후 처음으로 '레저'를 클릭하면 로깅,
     *하지만 동일 페이지에서 두 번째로 '레저'를 클릭할 경우 로깅하지 않음)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L96}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    bg({ logMeta }: ProductListPageLog.SearchTabBtnName.Bg) {
      return KinesisTracker.bg('PRODUCT_LIST', {
        clientEventId: 606,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'tabName',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_BG',
        ...logMeta,
      });
    },
  },

  SearchTabBtnMore: {
    /**
     * 더보기 버튼 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L112}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/tab_item.proto#L0}
     */
    impression({ logMeta }: ProductListPageLog.SearchTabBtnMore.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 697,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'tabMore',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },

    /**
     * 더보기 버튼 클릭
     * 펼쳐지기 전, 펼쳐졌을때 모두 클릭될 수 있음
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L125}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/tab_item.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchTabBtnMore.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 698,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'tabMore',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  SearchTabBtnVerticalItem: {
    /**
     * 더보기 레이어 내 버티컬 클릭
     * # 캘린더 & 인원 설정
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L139}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/tab_item.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchTabBtnVerticalItem.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 699,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'verticalTabItem',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  SearchButtonCheckInOutDateAndSetPeople: {
    /**
     * 체크인아웃 날짜 및 인원수 클릭
     * ## 캘린더 & 인원설정 bottom sheet
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L153}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchButtonCheckInOutDateAndSetPeople.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 607,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'checkInOutDateAndSetPeople',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  SearchButtonCheckInOutDate: {
    /**
     * bottom sheet 내에서 체크인아웃 날짜 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L167}
     * ProductListCheckInOutDateAndSetPeopleClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L59}
     */
    click({ containerDetail, sourcePage, locationInfo, logMeta }: ProductListPageLog.SearchButtonCheckInOutDate.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 609,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'checkInOutDate',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchButtonSetPeople: {
    /**
     * bottom sheet 내에서 인원 변경 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L181}
     * ProductListCheckInOutDateAndSetPeopleClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L59}
     */
    click({ containerDetail, sourcePage, locationInfo, logMeta }: ProductListPageLog.SearchButtonSetPeople.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 610,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'setPeople',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchLabelChangeCheckInOutDate: {
    /**
     * 리스트 내 날짜 변경 완료 (설정 후 확인 클릭 시, 변경된 날짜 로깅)
     * 실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가함
     *# 퀵 필터
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L195}
     * CheckInOutDateAndSetPeopleClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/misc.proto#L74}
     */
    bg({
      checkInDate,
      checkOutDate,
      roomPeople,
      exbusClass,
      logMeta,
    }: ProductListPageLog.SearchLabelChangeCheckInOutDate.Bg) {
      return KinesisTracker.bg('PRODUCT_LIST', {
        clientEventId: 611,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'changeCheckInOutDate',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_BG',
        checkInDate,
        checkOutDate,
        roomPeople,
        exbusClass,
        ...logMeta,
      });
    },
  },

  SearchButtonQuickFilter: {
    /**
     * SearchResult 상품 목록 내 퀵필터 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L211}
     * ProductListQuickFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L30}
     */
    impression({ selected, sourcePage, locationInfo, logMeta }: ProductListPageLog.SearchButtonQuickFilter.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 612,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'quickFilter',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        selected,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },

    /**
     * SearchResult 상품 목록 내 퀵필터 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L225}
     * ProductListQuickFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L30}
     */
    click({ selected, sourcePage, locationInfo, logMeta }: ProductListPageLog.SearchButtonQuickFilter.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 613,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'quickFilter',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        selected,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchButtonFilterList: {
    /**
     * SearchResult 상품 목록 내 리스트 필터 클릭
     * 클릭시 '필터 항목 리스트' 화면이 보임
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L239}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchButtonFilterList.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 614,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'filterList',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  SearchButtonSetSort: {
    /**
     * SearchResult 상품 목록 내 '정렬' 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L253}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    impression({ logMeta }: ProductListPageLog.SearchButtonSetSort.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 615,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'setSort',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },

    /**
     * SearchResult 상품 목록 내 '정렬' 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L266}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchButtonSetSort.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 616,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'setSort',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  SearchButtonSetSortComplete: {
    /**
     * SearchResult 퀵필터 중 '정렬' 변경 적용
     * 정렬의 경우 적용 버튼이 따로 존재함
     *## 필터 리스트
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L279}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchButtonSetSortComplete.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 617,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'setSortComplete',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  SearchLabelSectionName: {
    /**
     * SearchResult 필터 리스트 - 각 영역 노출
     * 라벨이 노출되는 시점에 남길 희망
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L294}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    impression({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
    }: ProductListPageLog.SearchLabelSectionName.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 618,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'sectionLabelName',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchSliderPriceRange: {
    /**
     * SearchResult 필터 리스트 - 가격 범위 슬라이더 조절
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L308}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
    }: ProductListPageLog.SearchSliderPriceRange.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 619,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'priceRangeSlider',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_SLIDER',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchTextFieldPriceRange: {
    /**
     * SearchResult 필터 리스트 - 가격 범위 커서 활성화
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L322}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
    }: ProductListPageLog.SearchTextFieldPriceRange.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 620,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'priceRangeTextField',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_TEXT_FIELD',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchButtonMore: {
    /**
     * SearchResult 필터 리스트 - 더보기 클릭
     * 더보기 버튼이 있는 영역 - 시설/서비스, 숙소 위치 영역
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L336}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({ containerDetail, minmax, sourcePage, locationInfo, logMeta }: ProductListPageLog.SearchButtonMore.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 621,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'more',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchButtonReset: {
    /**
     * SearchResult 필터 리스트 - 초기화 버튼 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L351}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({ containerDetail, minmax, sourcePage, locationInfo, logMeta }: ProductListPageLog.SearchButtonReset.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 581,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'reset',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchButtonFilterListComplete: {
    /**
     * SearchResult 필터 리스트 - 필터 적용 버튼 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L365}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
    }: ProductListPageLog.SearchButtonFilterListComplete.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 582,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'filterListComplete',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchLabelNoResult: {
    /**
     * SearchResult 필터 리스트 - 적용 버튼 noResult 노출
     * 적용 버튼이 noResult 활성화 될 때 노출 로그 발생 (어떤 조합으로 noResult 가 발생하는지 확인 가능 용도)
     *# 리스트 내 상품 - 국내숙소, 레저/티켓, 해외숙소 각각 정의
     *## 국내숙소
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L379}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    impression({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
    }: ProductListPageLog.SearchLabelNoResult.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 583,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'noResult',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchCardPlaceNo: {
    /**
     * SearchResult - 상품 리스트 내 국내숙소 상품 노출
     * objectsWith를 신규로그에 대해 사용하지 않기로 했으나, objectWith 참조하는 곳 파악이 필요하여 objectWith와 신규서버로그에 동일한 정보 전달
     *https://docs.google.com/document/d/1n0zLiXqYVAr3aQNwJHVq1FxYAPQXi0-Cdr2xc7-aWWk/edit#heading=h.48viz2kqokmm
     *영향을 주는 레거시가 많기 때문에 해당 부분은 실제 데이터는 들어가지만 정보는 주석으로 정리함. - 하지만, "실제로는 남기는 값"
     *objects_with : [{ $placeNo, $position, $adSlot?, $adSlotId?, $adSeq?, $adTags?, $positionInSlot?, $b2bCouponAd?,
     *$b2bCouponPlus?, $hotDeal?, $badgeInfo,
     *$hasRentInventory, $hasStayInventory, $rentPriceMemberCode?,$stayPriceMemberCode?,$badgeMemberCode?,
     *rent_coupons, $stay_coupons }]
     **** SRP 버티컬 탭 통합 전까지는 objectsWith에 아래의 message가 들어가야 합니다.
     *# 노출 로그가 하나였을 때는 ['{상품}', '{상품}', '{상품}'] 형식이었으나, 상품별로 로그를 발생시키면서
     *# ['{상품}']의 형태로 들어갑니다. # 이미지: https://screen.yanolja.in/tk2HqoGV2u68aRqF.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L398}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.SearchCardPlaceNo.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 584,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'placeNo',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * SearchResult - 상품 리스트 내 국내숙소 상품 클릭
     * ## 레저/티켓
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L425}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.SearchCardPlaceNo.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 585,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'placeNo',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  SearchCardLeisureTicketNo: {
    /**
     * SearchResult - 상품 리스트 내 레저 상품 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L440}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.SearchCardLeisureTicketNo.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 586,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'leisureTicketNo',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * SearchResult - 상품 리스트 내 레저 상품 클릭
     * ## 해외숙소
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L454}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.SearchCardLeisureTicketNo.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 587,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'leisureTicketNo',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  SearchCardPropertyMasterId: {
    /**
     * SearchResult - 상품 리스트 내 해외숙소 상품 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L469}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.SearchCardPropertyMasterId.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 588,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'propertyMasterId',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * SearchResult - 상품 리스트 내 해외숙소 상품 클릭
     * ## 공연/전시
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L483}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.SearchCardPropertyMasterId.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 589,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'propertyMasterId',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  SearchCardProductId: {
    /**
     * SearchResult - 상품 리스트 내 공연/전시 상품 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L498}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.SearchCardProductId.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 721,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'productId',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * SearchResult - 상품 리스트 내 공연/전시 상품 클릭
     * # No Results 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L512}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.SearchCardProductId.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 722,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'productId',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  SearchLabelNoAvailableProductMsg: {
    /**
     * 검색결과 또는 필터 적용- NoResult 노출 *글로벌 필터만으로는 NoResult가 발생하지 않지만, 퀵 필터와의 조합을 통해 NoResult가 발생할 수 있음
     * 실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가
     *과거 국내숙소, 해외숙소에서는 NoAvailablePlaceMsg, 레저에서는 NoAvailableLeisureMsg
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L528}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/global_filter.proto#L0}
     */
    impression({ logMeta }: ProductListPageLog.SearchLabelNoAvailableProductMsg.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 590,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'noAvailableProductMsg',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },
  },

  SearchLabelSpellCorrectionMsg: {
    /**
     * 검색결과 철자 오류 보정 키워드 리스트 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L541}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/global_filter.proto#L0}
     */
    impression({ logMeta }: ProductListPageLog.SearchLabelSpellCorrectionMsg.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 591,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'spellCorrectionMsg',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },

    /**
     * 검색결과 철자 오류 보정 키워드 리스트 클릭
     * # 함께 찾는 검색어
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L554}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/global_filter.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchLabelSpellCorrectionMsg.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 592,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'spellCorrectionMsg',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  RelatedKeywordsLabel: {
    /**
     * 함께 찾는 검색어 노출
     * 실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L569}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/related_keyword_item.proto#L0}
     */
    impression({ logMeta }: ProductListPageLog.RelatedKeywordsLabel.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 593,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'keywords',
        objectContainer: 'relatedKeywords',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },
  },

  RelatedKeywordsLabelSelectedKeyword: {
    /**
     * 함께 찾는 검색어 클릭
     * # recommendSection
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L582}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.RelatedKeywordsLabelSelectedKeyword.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 594,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'selectedKeyword',
        objectContainer: 'relatedKeywords',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  RecommendSectionCardWidgetItem: {
    /**
     * 추천 위젯 내 상품 노출
     * objectsWith를 23년 5월 이후로 신규로그에 대해 사용하지 않기로 했으나, objectWith 참조하는 곳 파악이 필요하여 objectWith와 신규서버로그에 동일한 정보 전달
     *https://docs.google.com/document/d/1n0zLiXqYVAr3aQNwJHVq1FxYAPQXi0-Cdr2xc7-aWWk/edit#heading=h.48viz2kqokmm
     *영향을 주는 레거시가 많기 때문에 해당 부분은 실제 데이터는 들어가지만 정보는 주석으로 정리함. - 하지만, "실제로는 남기는 값"
     *objects_with : [{ $placeNo, $position, $adSlot?, $adSlotId?, $adSeq?, $adTags?, $positionInSlot?, $b2bCouponAd?,
     *$b2bCouponPlus?, $hotDeal?, $badgeInfo,
     *$hasRentInventory, $hasStayInventory, $rentPriceMemberCode?,$stayPriceMemberCode?,$badgeMemberCode?,
     *rent_coupons, $stay_coupons }]
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L598}
     * ProductListRecommendSectionCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L69}
     */
    impression({
      position,
      listPosition,
      noAvailablePlaceMsg,
      sourcePage,
      locationInfo,
      logMeta,
    }: ProductListPageLog.RecommendSectionCardWidgetItem.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 595,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'widgetItem',
        objectContainer: 'recommendSection',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        listPosition,
        noAvailablePlaceMsg,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },

    /**
     * 국내숙소 리스트 - 추천 위젯 내 상품 클릭
     * ## OMBanner
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L619}
     * ProductListRecommendSectionCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L69}
     */
    click({
      position,
      listPosition,
      noAvailablePlaceMsg,
      sourcePage,
      locationInfo,
      logMeta,
    }: ProductListPageLog.RecommendSectionCardWidgetItem.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 596,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'widgetItem',
        objectContainer: 'recommendSection',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        listPosition,
        noAvailablePlaceMsg,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  SearchBannerOm: {
    /**
     * OMBanner 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L635}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.SearchBannerOm.Impression) {
      return KinesisTracker.impression('PRODUCT_LIST', {
        clientEventId: 622,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'OMBanner',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * OMBanner 클릭
     * ## 지도
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L649}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: ProductListPageLog.SearchBannerOm.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 623,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'OMBanner',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  SearchButtonSetMapview: {
    /**
     * 리스트 지도뷰 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/web.txtpb#L665}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta }: ProductListPageLog.SearchButtonSetMapview.Click) {
      return KinesisTracker.click('PRODUCT_LIST', {
        clientEventId: 597,
        pageName: 'PAGE_NAME_PRODUCT_LIST',
        object: 'setMapview',
        objectContainer: 'search',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace ProductListPageLog {
  export namespace Search {
    /**
     * # Header
     */
    export interface View {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonBackward {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonHome {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonCart {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace ButtonSearch {
    /**
     * # 카테고리 탭
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchTabBtnDisplayName {
    /**
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchTabBtnName {
    /**
     * 사용자가 ProductList 페이지에 진입한 초기 카테고리와 다른 카테고리를 처음 클릭한 경우 로깅
     *(예: '국내숙소' 카테고리에서 진입 후 처음으로 '레저'를 클릭하면 로깅,
     *하지만 동일 페이지에서 두 번째로 '레저'를 클릭할 경우 로깅하지 않음)
     */
    export interface Bg {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchTabBtnMore {
    /**
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * 펼쳐지기 전, 펼쳐졌을때 모두 클릭될 수 있음
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchTabBtnVerticalItem {
    /**
     * # 캘린더 & 인원 설정
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonCheckInOutDateAndSetPeople {
    /**
     * ## 캘린더 & 인원설정 bottom sheet
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonCheckInOutDate {
    /**
     */
    export interface Click {
      /* 해당 모달에 관한 값: {&#39;containerDetail&#39; : &#39;bottomSheet&#39;}*/
      containerDetail: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonSetPeople {
    /**
     */
    export interface Click {
      /* 해당 모달에 관한 값: {&#39;containerDetail&#39; : &#39;bottomSheet&#39;}*/
      containerDetail: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchLabelChangeCheckInOutDate {
    /**
     * 실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가함
     *# 퀵 필터
     */
    export interface Bg {
      /* 바텀싯관련 정보 - &lt;날짜 변경 완료 bg 로그&gt; 에만 추가*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* 객실 정보.*/
      roomPeople?: RoomPeople[];
      /* 버스 등급 ex) 전체, 프리미엄, 우등, 일반... 심야프리미엄... 등*/
      exbusClass?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonQuickFilter {
    /**
     */
    export interface Impression {
      /* 실제 노출 되는 값 : {&#34;selected&#34;: True } / {&#34;selected&#34;:False}*/
      selected?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     */
    export interface Click {
      /* 실제 노출 되는 값 : {&#34;selected&#34;: True } / {&#34;selected&#34;:False}*/
      selected?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonFilterList {
    /**
     * 클릭시 '필터 항목 리스트' 화면이 보임
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonSetSort {
    /**
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonSetSortComplete {
    /**
     * 정렬의 경우 적용 버튼이 따로 존재함
     *## 필터 리스트
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchLabelSectionName {
    /**
     * 라벨이 노출되는 시점에 남길 희망
     */
    export interface Impression {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchSliderPriceRange {
    /**
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchTextFieldPriceRange {
    /**
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonMore {
    /**
     * 더보기 버튼이 있는 영역 - 시설/서비스, 숙소 위치 영역
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonReset {
    /**
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonFilterListComplete {
    /**
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchLabelNoResult {
    /**
     * 적용 버튼이 noResult 활성화 될 때 노출 로그 발생 (어떤 조합으로 noResult 가 발생하는지 확인 가능 용도)
     *# 리스트 내 상품 - 국내숙소, 레저/티켓, 해외숙소 각각 정의
     *## 국내숙소
     */
    export interface Impression {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchCardPlaceNo {
    /**
     * objectsWith를 신규로그에 대해 사용하지 않기로 했으나, objectWith 참조하는 곳 파악이 필요하여 objectWith와 신규서버로그에 동일한 정보 전달
     *https://docs.google.com/document/d/1n0zLiXqYVAr3aQNwJHVq1FxYAPQXi0-Cdr2xc7-aWWk/edit#heading=h.48viz2kqokmm
     *영향을 주는 레거시가 많기 때문에 해당 부분은 실제 데이터는 들어가지만 정보는 주석으로 정리함. - 하지만, "실제로는 남기는 값"
     *objects_with : [{ $placeNo, $position, $adSlot?, $adSlotId?, $adSeq?, $adTags?, $positionInSlot?, $b2bCouponAd?,
     *$b2bCouponPlus?, $hotDeal?, $badgeInfo,
     *$hasRentInventory, $hasStayInventory, $rentPriceMemberCode?,$stayPriceMemberCode?,$badgeMemberCode?,
     *rent_coupons, $stay_coupons }]
     **** SRP 버티컬 탭 통합 전까지는 objectsWith에 아래의 message가 들어가야 합니다.
     *# 노출 로그가 하나였을 때는 ['{상품}', '{상품}', '{상품}'] 형식이었으나, 상품별로 로그를 발생시키면서
     *# ['{상품}']의 형태로 들어갑니다. # 이미지: https://screen.yanolja.in/tk2HqoGV2u68aRqF.png
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * ## 레저/티켓
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchCardLeisureTicketNo {
    /**
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * ## 해외숙소
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchCardPropertyMasterId {
    /**
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * ## 공연/전시
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchCardProductId {
    /**
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * # No Results 노출
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchLabelNoAvailableProductMsg {
    /**
     * 실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가
     *과거 국내숙소, 해외숙소에서는 NoAvailablePlaceMsg, 레저에서는 NoAvailableLeisureMsg
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchLabelSpellCorrectionMsg {
    /**
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * # 함께 찾는 검색어
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace RelatedKeywordsLabel {
    /**
     * 실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace RelatedKeywordsLabelSelectedKeyword {
    /**
     * # recommendSection
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace RecommendSectionCardWidgetItem {
    /**
     * objectsWith를 23년 5월 이후로 신규로그에 대해 사용하지 않기로 했으나, objectWith 참조하는 곳 파악이 필요하여 objectWith와 신규서버로그에 동일한 정보 전달
     *https://docs.google.com/document/d/1n0zLiXqYVAr3aQNwJHVq1FxYAPQXi0-Cdr2xc7-aWWk/edit#heading=h.48viz2kqokmm
     *영향을 주는 레거시가 많기 때문에 해당 부분은 실제 데이터는 들어가지만 정보는 주석으로 정리함. - 하지만, "실제로는 남기는 값"
     *objects_with : [{ $placeNo, $position, $adSlot?, $adSlotId?, $adSeq?, $adTags?, $positionInSlot?, $b2bCouponAd?,
     *$b2bCouponPlus?, $hotDeal?, $badgeInfo,
     *$hasRentInventory, $hasStayInventory, $rentPriceMemberCode?,$stayPriceMemberCode?,$badgeMemberCode?,
     *rent_coupons, $stay_coupons }]
     */
    export interface Impression {
      /**
       * * 위젯 정보 ****  #https://screen.yanolja.in/1voQZsLupI0zBp1L.png
       *위젯 내 상품 순서 (광고의 positionInSlot과 유사한 개념)
       */
      position: number;
      /* 전체 상품 리스트 내 상품 순서 (광고, 일반 상품까지 모두 포함한 상품 리스트 내 상품 순서로 상품 로그의 position과 유사한 개념)*/
      listPosition: number;
      /* 검색결과 - NoResult 노출*/
      noAvailablePlaceMsg?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * ## OMBanner
     */
    export interface Click {
      /**
       * * 위젯 정보 ****  #https://screen.yanolja.in/1voQZsLupI0zBp1L.png
       *위젯 내 상품 순서 (광고의 positionInSlot과 유사한 개념)
       */
      position: number;
      /* 전체 상품 리스트 내 상품 순서 (광고, 일반 상품까지 모두 포함한 상품 리스트 내 상품 순서로 상품 로그의 position과 유사한 개념)*/
      listPosition: number;
      /* 검색결과 - NoResult 노출*/
      noAvailablePlaceMsg?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchBannerOm {
    /**
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * ## 지도
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchButtonSetMapview {
    /**
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
}
